import React from 'react';

import { connect } from 'react-redux';

/**
 * https://api.trypatchwork.com/facebook/callback?
 *      code=<big_long_code>
 *      &state=%7B%22account_id%22%3A%22f126c00b-fc5b-4655-b5ce-aed96599410c%22%7D#_=_
 */
class FacebookController extends React.Component
{
    componentDidMount()
    {
        const query = new URLSearchParams(window.location.search);

        const code = query.get('code');
        const state = query.get('state');

        if (! code || ! state) {
            return <p>Something went wrong.</p>;
        }

        window.location = process.env.API_URL + '/facebook/callback?code=' + code + '&state=' + encodeURI(state);
    }

    render()
    {
        return null;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
});

export default connect(mapStateToProps)(FacebookController);
